/**
 * Local-storage keys for the browser session.
 *
 * Kept in their own module — free of `import.meta.env` — so pure logic that touches
 * the session (e.g. account switching) can be unit-tested outside vite.
 * Re-exported from `@/config/constants`, which remains the canonical import site.
 */
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
  IMPERSONATED_ACCOUNT: 'impersonatedAccount',
  QUOTE: 'quote',
} as const;
